import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dehruvhxlhzxypudtstt.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRlaHJ1dmh4bGh6eHlwdWR0c3R0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI5NTcxNTAsImV4cCI6MjA5ODUzMzE1MH0.yFhgXlm-_OTgSLKi-pDKLZrSemy81uJgn2SuJdZntnU';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
